/** One colour per seat, used for pawns, portraits and the players panel. */
export const kSeatColors = ["#e0b84a", "#58b0d6", "#d26a6a", "#7cc47a", "#b48ad8", "#e08a3c"];
